/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contentreportsdate2Inputs */

const en_contentreportsdate2 = /** @type {(inputs: Contentreportsdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const de_contentreportsdate2 = /** @type {(inputs: Contentreportsdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

/**
* | output |
* | --- |
* | "Date" |
*
* @param {Contentreportsdate2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const contentreportsdate2 = /** @type {((inputs?: Contentreportsdate2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contentreportsdate2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contentreportsdate2(inputs)
	return de_contentreportsdate2(inputs)
});
export { contentreportsdate2 as "contentReportsDate" }